// Styles for LinkBanner go here.
import { contextualVariable } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledLinkBanner = styled.div`
  .lb__container a {
    color: ${contextualVariable.accentColor};
  }
`;
